<template>
  <section class="section section-steps bg-cream-deep">
    <div class="container pt-40 pb-60">
      <div class="grid justify-between items-end grid-template-columns-2 mb-40">
        <h2 class="how-it-work w-fit brand-green fw-600 fs-12 lh-15 ttu ls-12">
          How it works
        </h2>
        <router-link
          class="w-fit justify-self-end fs-14 lh-20"
          :to="{ path: `/how-it-works` }"
          >See how it works</router-link
        >
      </div>
      <div
        class="grid grid-gap-40"
        :class="[$device.isDesktopOrTablet ? 'grid-template-columns-3' : '']"
      >
        <div class="enquire flex flex-row grid-gap-20 items-center mb-items-start">
          <img
            :src="`${ASSETS_CDN}/images/home/icons/step-enquire-v2.svg`" width='60' height='60' alt='Explore icon'
          />
          <div class="content">
            <h3 class="fw-600 fs-20 lh-24 mb-8 tl-mb-6">1. Explore</h3>
            <p class="fs-16 lh-24 mb-0">
              Get inspired by our gallery of 2000+ extraordinary travel
              journeys.
            </p>
          </div>
        </div>
        <div class="build flex flex-row grid-gap-20 items-center mb-items-start">
          <img
            :src="`${ASSETS_CDN}/images/home/icons/step-build-v2.svg`" width='60' height='60' alt='Design icon'
          />
          <div class="content">
            <h3 class="fw-600 fs-20 lh-24 mb-8 tl-mb-6">2. Design</h3>
            <p class="fs-16 lh-24 mb-0">
              Work with a Local Designer to design your extraordinary
              trip.
            </p>
          </div>
        </div>
        <div class="book flex flex-row grid-gap-20 items-center mb-items-start">
          <img
            :src="`${ASSETS_CDN}/images/home/icons/step-book-v2.svg`" width='60' height='60' alt='Book icon'
          />
          <div class="content">
            <h3 class="fw-600 fs-20 lh-24 mb-8 tl-mb-6">3. Book</h3>
            <p class="fs-16 lh-24 mb-0">
              Book with confidence through the secure Designer Journeys
              platform.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
// import { PHONE } from '~/constant/common'
import {assetCDN} from '~/helper/index.js';

const ASSETS_CDN = assetCDN()

// const windowWidth = computed(
//   () => store.state.generalStore.generalData.windowWidth,
// )
</script>
<style lang="scss" scoped>
.section-steps {
  .container {
    padding: 40px 80px 60px 80px;

    @include tablet {
      padding: 40px 60px 60px;
    }

    @include phone {
      padding: 40px 20px 60px;
    }
  }

  // §9 text link — green, no resting underline; gold + underline on hover
  a {
    color: $link;
    text-decoration: none;
    transition: color $dur-fast $ease-out;
    @include focus-ring;
    &:hover {
      color: $link-strong; // v2 §7/§Link — hover darkens to Green Deep (gold text on cream fails AA); underline stays
      text-decoration: underline;
    }
  }

  // .how-it-work kicker tracking now comes from the global .ls-12 utility (0.12em, v2 green
  // section-label) applied in the template — no scoped override here (a scoped rule would
  // out-specify the utility and re-pin the retired 0.08em, as the W4 re-run gate caught).
}
</style>
